import { Heart } from "lucide-react";

/**
 * StudentLovedBadge
 * -----------------------------------------------------------------------------
 * Small trust-signal badge shown on any degree card whose satisfaction stats
 * meet the "Student-loved" thresholds (backend constants — kept in one place
 * in server.py so this component only has to trust the boolean).
 *
 * The badge NEVER falls back to "not loved" copy — we simply render nothing
 * when the flag is false so the UI stays clean for the long tail of degrees
 * with zero or middling reviews.
 */
export default function StudentLovedBadge({
  stats,
  size = "sm",
  testid,
}) {
  if (!stats || !stats.student_loved) return null;

  const av = stats.averages || {};
  const sizeCls =
    size === "lg"
      ? "text-xs px-2.5 py-1"
      : size === "xs"
      ? "text-[9px] px-1.5 py-0.5"
      : "text-[10px] px-2 py-0.5";
  const iconCls =
    size === "lg" ? "h-3.5 w-3.5" : size === "xs" ? "h-2.5 w-2.5" : "h-3 w-3";

  return (
    <span
      data-testid={testid || "student-loved-badge"}
      title={
        av.overall
          ? `${av.overall}/5 · ${av.recommend_pct}% recommend · ${stats.count} reviews`
          : `${stats.count} student review${stats.count === 1 ? "" : "s"}`
      }
      className={`inline-flex items-center gap-1 rounded-full border border-rose-200 bg-rose-50 text-rose-800 font-medium uppercase tracking-wider ${sizeCls}`}
    >
      <Heart className={`${iconCls} fill-rose-600 text-rose-600`} />
      Student-loved
    </span>
  );
}
